import React from "react";

export const DropDownIcon = () => {
  return (
    <div>
      <svg
        width="13"
        height="9"
        viewBox="0 0 13 9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2943 0.471614C12.9232 1.08828 12.933 2.09795 12.3163 2.72677L7.57911 7.55734C6.96245 8.18616 5.95278 8.19601 5.32396 7.57934L0.493387 2.84212C-0.135431 2.22545 -0.145282 1.21579 0.471384 0.586967C1.08805 -0.041852 2.09772 -0.051703 2.72654 0.564964L6.41853 4.18561L10.0392 0.493617C10.6559 -0.135202 11.6655 -0.145053 12.2943 0.471614Z"
        />
      </svg>
    </div>
  );
};
